import GoogleMaps from "./GoogleMaps";
import getCurrentLocation from '../getCurrentLocation';
class Overview extends GoogleMaps {
	async init() {
		let result = await super.init();
		this.$scope
			.on('change', `${this.config.search} form [name="search"]`, this._onSearch.bind(this))
			.on('submit', `${this.config.search} form`, this._onSubmit.bind(this))
			.on('click', this.config.pageLink, this._setPage.bind(this))
			.on('change', this.config.tag, this._setTag.bind(this));

		if (!this.request.request.search) {
			await this._getCurrentPosition();
		}
		if (this.request.request.search) {
			this.search();
		}

		return result;
	}

	search(reloadMap = true) {
		this.request.request = {
			...this.request.request,
			reloadMap: reloadMap ? 1 : 0,
		}

		$.ajax({
			method: 'get',
			url: window.location.pathname,
			data: this.request.request,
			success: this._onSuccess.bind(this, reloadMap)
		});
	}

	_setPage(event) {
		event.preventDefault();
		this.request.request.page = $(event.currentTarget).data('page');
		this.search(false);
		$([document.documentElement, document.body]).animate({
			scrollTop: this.$scope.find(this.config.grid).offset().top - 150
		}, 250);
	}

	_setTag(event) {
		let $input = $(event.currentTarget);
		if (!this.request.request.tag) {
			this.request.request.tag = {};
		}

		if ($input.is(':checked')) {
			if ($input.val() === 'all') {
				this.request.request.tag = {};
			} else {
				this.request.request.tag[$input.data('id')] = $input.data('title');
			}
		} else {
			try {
				delete this.request.request.tag[$input.data('id')];
			} catch (error) {
			}
		}

		this.request.request.page = 1;
		this.search();
	}

	_onSearch(event) {
		this.request.request.search = $(event.currentTarget).val();
		this.request.request.page = 1;
		this.search();
	}

	_onSubmit(event) {
		event.preventDefault();
		this.search();
	}

	_onSuccess(reloadMap, response) {
		this.$scope.find(this.config.search).html(response.search);
		this.$scope.find(this.config.grid).html(response.grid);
		this.$scope.find(this.config.pagination).html(response.pagination);
		if (reloadMap) {
			this.setMarkers(response.markers);
		}
		delete this.request.request.reloadMap;
		delete this.request.request.tree_id;
		history.pushState(this.request, 'step', window.location.pathname + '?' + jQuery.param(this.request.request));
	}

	_getCurrentPosition() {
		return getCurrentLocation().then((data) => {
			if (!data.address) {
				return;
			}
			this.$scope.find(`${this.config.search} form input[name="search"]`).val(data.address);
			this.request.request.search = data.address;
		});
	}
}

let overview = new Overview({
	search: '[data-google-maps="search"]',
	grid: '[data-google-maps="grid"]',
	pagination: '[data-google-maps="pagination"]',
	pageLink: '[data-page]',
	tag: '[data-tags]',
});

if ($(overview.config.scope).length > 0) {
	overview.init();
}

export default overview;